"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVariantClassName = exports["default"] = exports.SelectedLink = exports.LinkComponent = exports.DecorationText = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["component", "children", "isButton"],
  _excluded2 = ["backIcon", "className", "hasIcon", "isButton", "typographyProps", "underline", "variant"],
  _excluded3 = ["className", "kind"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "selectedLink": "xM-IWQ",
  "underline": "A3yNXY",
  "decorationText": "_2Oxipy",
  "defaultDecorationText": "_4d2XiE",
  "inverseDecorationText": "FbgvZR",
  "lighterDecorationText": "v62Dm1",
  "inverseLighterDecorationText": "Mx5xvu",
  "default": "a8Esh3",
  "inverse": "_4p1JSA",
  "isButton": "xxk4P7",
  "hasIcon": "uBedic",
  "backIcon": "-POvPm"
};
var typographyStyles = {
  "heroLarge": "mosXtW",
  "heroMedium": "_4xFzPA",
  "heroSmall": "zWHvO-",
  "display": "k-ohj4",
  "heading": "_7pZbty",
  "title": "EqjlRj",
  "bodyStrong": "A68t3o",
  "body": "Ci-jp3",
  "captionStrong": "pwAPLE",
  "caption": "_1tBHcU"
};
var LinkComponent = exports.LinkComponent = function LinkComponent(_ref) {
  var Link = _ref.component,
    children = _ref.children,
    isButton = _ref.isButton,
    props = _objectWithoutProperties(_ref, _excluded);
  return Link ? /*#__PURE__*/_react["default"].createElement(Link, props, children) : /*#__PURE__*/_react["default"].createElement("a", props, children);
};
LinkComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  component: _propTypes["default"].elementType,
  children: _propTypes["default"].node,
  'aria-label': _propTypes["default"].string,
  to: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  href: _propTypes["default"].string,
  isButton: _propTypes["default"].bool
} : {};
var getTypographyLevelClassName = function getTypographyLevelClassName(level) {
  if (!level) {
    return typographyStyles.body;
  }
  return typographyStyles[level] || typographyStyles.body;
};
var getVariantClassName = exports.getVariantClassName = function getVariantClassName(kind) {
  return styles[kind] || styles["default"];
};
var SelectedLink = exports.SelectedLink = function SelectedLink(_ref2) {
  var backIcon = _ref2.backIcon,
    className = _ref2.className,
    hasIcon = _ref2.hasIcon,
    isButton = _ref2.isButton,
    typographyProps = _ref2.typographyProps,
    underline = _ref2.underline,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(LinkComponent, _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.selectedLink, getVariantClassName(variant), isButton && styles.isButton, isButton && getTypographyLevelClassName(typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.level), hasIcon && styles.hasIcon, backIcon && styles.backIcon, underline && styles.underline)
  }));
};
SelectedLink.propTypes = process.env.NODE_ENV !== "production" ? {
  backIcon: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  hasIcon: _propTypes["default"].bool,
  isButton: _propTypes["default"].bool,
  isCaption: _propTypes["default"].bool,
  typographyProps: _propTypes["default"].object,
  underline: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['default', 'inverse'])
} : {};
var getDecorationTextKindClassName = function getDecorationTextKindClassName(kind) {
  switch (kind) {
    case 'inverse':
      return styles.inverseDecorationText;
    case 'lighter':
      return styles.lighterDecorationText;
    case 'inverseLighter':
      return styles.inverseLighterDecorationText;
    default:
      return styles.defaultDecorationText;
  }
};
var DecorationText = exports.DecorationText = function DecorationText(_ref3) {
  var className = _ref3.className,
    kind = _ref3.kind,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement("span", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.decorationText, getDecorationTextKindClassName(kind))
  }));
};
DecorationText.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  kind: _propTypes["default"].oneOf(['default', 'inverse', 'lighter', 'inverseLighter'])
} : {};
var _default = exports["default"] = SelectedLink;